import React from 'react';
import { ShiftTypeTranslationKeys } from './ShiftTypeFilterTypes';
import { CheckboxList } from '../../../shared';
import { useTranslation } from 'react-i18next';
import { useLabelTextMap } from '../useLabelMap';
import { getCheckboxItems } from '../getCheckboxItems';
export var ShiftTypeFilter = function (_a) {
    var shiftTypeFilterState = _a.shiftTypeFilterState, shiftTypeFilterOptions = _a.shiftTypeFilterOptions, onFilterStateChange = _a.onFilterStateChange;
    var t = useTranslation().t;
    var labels = useLabelTextMap(ShiftTypeTranslationKeys);
    var checkboxListItems = getCheckboxItems(shiftTypeFilterOptions, {
        labelTextMap: labels
    });
    return (React.createElement(CheckboxList, { title: t('shift_management_views_filters_payType_title'), dataTestId: "shift-type-filters", checkboxState: shiftTypeFilterState, onStateChange: onFilterStateChange, checkboxListItems: checkboxListItems }));
};
